/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
    <div class="course-chunk">
        <p class="p1">{{$t("about.journey")}}</p>
        <div class="details-div">
            <div class="details-wrap">
                <template v-for="item in detailsList">
                    <transition name="node">
                        <div class="details" v-show="item.show">
                            <span class="year">{{item.year}}</span>
                            <div>
                                <!--<strong>{{item.title}}</strong>-->
                                <p v-html="item.content"></p>
                            </div>
                        </div>
                    </transition>
                </template>
            </div>
        </div>
        <div class="content-wrap">
            <div :class="`node ${item.show?'active':''}`" v-for="(item,index) in detailsList"
                 @mouseenter="onMouseenter(index)">
                <div class="line"></div>
                <p class="date">{{item.year}}</p>
                <div class="dot"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "course-chunk",
        data() {
            return {
                detailsList: [
                    {
                        year: 2025,
                        title: "完成股改",
                        content: this.$t("about.history2025"),
                        show: true
                    },
                    {
                        year: 2024,
                        title: "成立分公司",
                        content: this.$t("about.history2024"),
                        show: false
                    },
                    {
                        year: 2023,
                        title: "建立海外分公司",
                        content: this.$t("about.history2023"),
                        show: false
                    },
                    {
                        year: 2022,
                        title: "荣获中国品牌100强",
                        content: this.$t("about.history2022"),
                        show: false
                    },
                    {
                        year: 2021,
                        title: "总部迁址苏州",
                        content: this.$t("about.history2021"),
                        show: false
                    },
                    {
                        year: 2020,
                        title: "建立呼叫中心",
                        content: this.$t("about.history2020"),
                        show: false
                    },
                    {
                        year: 2019,
                        title: "成立分公司",
                        content: this.$t("about.history2019"),
                        show: false
                    },
                    {
                        year: 2017,
                        title: "新加坡办公室",
                        content: this.$t("about.history2017"),
                        show: false
                    },
                    {
                        year: 2016,
                        title: "成立科睿克",
                        content: this.$t("about.history2016"),
                        show: false
                    },
                    {
                        year: 2015,
                        title: "成立科林利康（苏州）",
                        content: this.$t("about.history2015"),
                        show: false
                    },
                    {
                        year: 2014,
                        title: "成立美达",
                        content: this.$t("about.history2009"),
                        show: false
                    },
                    // {
                    //     year: 2009,
                    //     title: "创始元年",
                    //     content: this.$t("about.history2009"),
                    //     show: false
                    // }
                ]
            }
        },
        methods: {
            onMouseenter(index) {
                for (let detail of this.detailsList) {
                    detail.show = false;
                }
                this.detailsList[index].show = true;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../style/constant";

    .course-chunk {
        width: @page-width;
        margin: 100px auto;
        position: relative;

        .p1 {
            font-size: 32px;
            text-align: center;
            font-weight: 500;
        }
        @media screen and (min-width: 320px) and (max-width: 480px) {
            .p1 {
                font-size: 24px;
            }
        }

        .content-wrap {
            display: flex;
            padding-bottom: 50px;
        }
        @media screen and (min-width: 320px) and (max-width: 480px) {
            .content-wrap {
              overflow-x: auto;
                padding-top: 100px;
            }
        }

        .details-wrap {
            position: relative;
            min-height: 200px;
            margin-top: 80px;
            margin-bottom: 50px;

            .details {
                position: absolute;
                display: flex;
                align-items: center;
                left: 200px;

                .year {
                    font-size: 60px;
                    font-weight: bold;
                    color: #435ba1;
                    margin-right: 10px;
                    line-height: 1;
                }
            }
            @media screen and (min-width: 320px) and (max-width: 480px) {
                .details {
                    left: 10px;
                    width: 80vw;
                    overflow-x: hidden;
                    .year {
                        font-size: 36px;
                    }
                }
            }
        }
        @media screen and (min-width: 320px) and (max-width: 480px) {
            .details-wrap {
                margin-bottom: 0px;
                margin-top: 40px;
            }
        }
        .node {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            color: #435ba1;
            cursor: pointer;

            .date {
                position: absolute;
                top: 10px;
                font-size: 20px;
                left: 50%;
                font-weight: bold;
            }

            .line {
                width: 100%;
                height: 2px;
                background-color: #7a7a7a;
            }
            @media screen and (min-width: 320px) and (max-width: 480px) {
                .line {
                    width: 90px;
                }
            }

            .dot {
                background-color: #4b8ad8;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                top: -6px;
                left: 50%;
                border: 5px solid #435ba1;
                z-index: 100;

                &::before {
                    content: '';
                    width: 1px;
                    display: block;
                    height: 0;
                    bottom: 7px;
                    left: 50%;
                    margin-left: -0.5px;
                    background-image: linear-gradient(0deg, rgba(67, 91, 161, 0.82) 43%, rgba(106, 202, 255, 0.00) 100%);
                    position: absolute;
                }
            }
        }

        .active {
            color: @active-color;

            .dot {
                transform: scale(1.3);

                &::before {
                    height: 100px;
                    transition: height .5s;
                }
            }
        }

        .node-enter {
            transform: translateY(10px);
            opacity: 0;
        }

        .node-enter-active {
            transition: transform .3s, opacity .3s;
        }

        .node-leave-active {
            transform: translateY(-20px);
            opacity: 0;
            transition: transform .3s, opacity .3s;
        }

    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .course-chunk {
            width: 90%;
        }
    }


</style>